/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import isElectron from 'is-electron';
import { useFetchPosProfileDetails } from '../user';
import {
  selectAuth,
  selectCart,
  selectDelivery,
  selectOrder,
  selectPrinter,
} from '@/store/selectors';
import { setAlert } from '@/store/slices/alert';
import { NewKOTType, UpdateKOTType } from '@/types/utils';
import { printKOT, PrinterKOTType, sortAndMergePrinter } from '@/utils/printer';
import { handleApiError } from '@/utils/helpers';
import { toogleServiceCharge } from '@/store/slices/order';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

let END_POINT: string;
const newKOTEndpoint =
  '/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.generate_kot';
const updateEndpoint =
  '/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.update_invoice';

const fetcher = (
  url: any,
  KOTData: NewKOTType | UpdateKOTType,
  serviceCharge: boolean,
) => {
  const response = axios({
    method: 'post',
    url: `https://${url}${END_POINT}`,
    data: { use_service_charge: serviceCharge ? 1 : 0, data: { ...KOTData } },
    withCredentials: true,
  })
    .then((data) => data)
    .catch((error) => error);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useCreateKOT = () => {
  const { url, fullName } = useSelector(selectAuth);
  const { default: defaultPrinter, kot: kotPrinter } =
    useSelector(selectPrinter);
  const { data: posProfile } = useFetchPosProfileDetails();
  const {
    delivery: deliveryDetails,
    deliveryName,
    toggleDelivery,
  } = useSelector(selectDelivery);
  const { items, subtotal } = useSelector(selectCart);
  const {
    restaurant_table,
    customer,
    current_invoice,
    discount,
    service_charge,
  } = useSelector(selectOrder);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  let KOTData: NewKOTType | UpdateKOTType;

  const delivery = toggleDelivery
    ? {
        ...deliveryDetails,
        ...(deliveryDetails?.name || !deliveryName
          ? {}
          : { name: deliveryName }),
        driver: 'Desktop driver',
        vehicle: 'Desktop vehicle',
        estimated_departure_time: new Date() ?? '',
        estimated_delivery_time: new Date() ?? '',
        company: posProfile?.company,
      }
    : null;

  // If a current invoice exists, create an update KOTData,
  // and update the endpoint to use the update invoice
  if (current_invoice) {
    KOTData = {
      name: current_invoice,
      discount_amount: discount,
      customer,
      items,
      delivery,
    };
    END_POINT = updateEndpoint;
  } else {
    KOTData = {
      company: posProfile?.company,
      restaurant: posProfile?.restaurant,
      restaurant_table,
      discount_amount: discount,
      customer,
      subtotal,
      items,
      pos_profile: posProfile,
      custom_wallet: 1,
      delivery,
    };

    END_POINT = newKOTEndpoint;
  }

  const handleSuccess = () => {
    dispatch(toogleServiceCharge(false));

    dispatch(
      setAlert({ type: 'success', message: 'KOT printed successfully' }),
    );

    navigate('/tables');
  };

  const handleError = (message: string) => {
    dispatch(setAlert({ type: 'error', message }));
    return;
  };

  const mutate = useMutation(() => fetcher(url, KOTData, service_charge), {
    onSettled: (data) => {
      if (!data.data) {
        const errorMessage = handleApiError(data);
        handleError(errorMessage);
      } else if (data.data) {
        let tableItems: any[] = [];

        let areas: any[] = [];

        const printerObjArr: PrinterKOTType[] = [];

        // Check if category printing is activated and then change the array
        // extraction format based on it.

        if (data.data.message?.kots?.length <= 1) {
          handleError('KOT List is empty');
        }

        if (posProfile?.print_based_on_category === 0) {
          tableItems = data.data.message?.kots[0].items;
        } else {
          const itemsArray = data.data.message?.kots.map(
            (kot: any) => kot.items,
          );

          tableItems = [].concat(...itemsArray);
        }

        const invoice = data.data.message?.invoice.name;
        const kotID = data.data.message?.kots[0].name;
        const createdAt = data.data.message?.kots[0].creation;

        queryClient.invalidateQueries(['KOT']);

        // Map the KOT areas
        if (posProfile?.map_kot_print_areas) {
          areas = posProfile?.map_kot_print_areas.map((print_area: any) => ({
            [print_area.item_group]: print_area.print_area,
          }));
        }

        if (
          posProfile?.print_based_on_category === 0 ||
          posProfile?.map_kot_print_areas?.length === 0
        ) {
          const printerObj = {
            port: defaultPrinter.port,
            ipAddress: defaultPrinter.ipAddress,
            invoice,
            kotID,
            discount,
            customer,
            waiter: fullName,
            table: restaurant_table,
            area: 'null',
            items: tableItems,
            reprinted: false,
            createdAt,
          };

          printerObjArr.push(printerObj);
        } else {
          tableItems.forEach((item: any) => {
            const printArea = areas.find((area) => area[item.item_group]);

            const printer = kotPrinter.find(
              (kot) => kot.area === printArea[item.item_group],
            );

            if (printer && isElectron()) {
              const printerObj = {
                port: printer!.port,
                ipAddress: printer!.ipAddress,
                invoice,
                kotID,
                customer,
                waiter: fullName,
                table: restaurant_table,
                area: printer!.area,
                items: item,
                reprinted: false,
                createdAt,
              };

              printerObjArr.push(printerObj);
            } else {
              const printerObj = {
                port: defaultPrinter.port,
                ipAddress: defaultPrinter.ipAddress,
                invoice,
                kotID,
                customer,
                discount,
                waiter: fullName,
                table: restaurant_table,
                area: printArea[item.item_group],
                items: item,
                reprinted: false,
                createdAt,
              };

              printerObjArr.push(printerObj);
            }
          });
        }

        // SORT AND PRINT KOT
        const printersArr = sortAndMergePrinter(printerObjArr);

        // printersArr.forEach((printer) => {
        //   if (isElectron()) {
        //     printKOT(printer);
        //   } else {
        //     localStorage.setItem(printer.area, JSON.stringify(printer));
        //     window.open(
        //       `/generate-kot?ref=${printer.area}`,
        //       '_blank',
        //       'noreferrer',
        //     );
        //   }
        // });

        if (isElectron()) {
          printersArr.forEach((printer) => {
            printKOT(printer);
          });
        } else {
          localStorage.setItem('kot', JSON.stringify(printersArr));
          window.open(`/generate-kot?ref=kot`, '_blank', 'noreferrer');
        }
        handleSuccess();
      }
    },
    onError: (error: any) =>
      // eslint-disable-next-line implicit-arrow-linebreak
      handleError(
        `${JSON.parse(error)}An Error Occured. Contact Administration`,
      ),
  });

  return mutate;
};
